import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class TiendaService {

  constructor(private config: ConfigService, private http: HttpClient) { }

  getInfoTienda(token: String, idTienda: number) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Tienda/" + idTienda;
    return this.http.get(url, requestOptions);
  }


  getTiendas(token: String, date: string) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Tienda/List/" + date;
    return this.http.get(url, requestOptions);
  }

  getVentasDiscriminacionPagoTienda(token: String, date: string, idTienda: number) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Tienda/Pagos/" + date + "/" + idTienda;
    return this.http.get(url, requestOptions);
  }

  getVentasDiscriminacionPagoTiendaAcumulado(token: String, dateIni: string, dateEnd: string, idTienda: number) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Tienda/PagosRango/" + dateIni + "/" + dateEnd + "/" + idTienda;
    return this.http.get(url, requestOptions);
  }


  getVentasDiscriminacionCanalTiendaAcumulado(token: String, dateIni: string, dateEnd: string, idTienda: number) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Tienda/CanalVenta/" + dateIni + "/" + dateEnd + "/" + idTienda;
    return this.http.get(url, requestOptions);
  }

  getVentasDiscriminacionVendedor(token: String, date: string, idTienda: number) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Tienda/VentaVendedores/" + date + "/" + idTienda;
    return this.http.get(url, requestOptions);
  }

  getVentasDiscriminacionVendedorAcumulado(token: String, dateIni: string, dateEnd: string, idTienda: number) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Tienda/VentaVendedoresAcumulado/" + dateIni + "/" + dateEnd + "/" + idTienda;
    return this.http.get(url, requestOptions);
  }

  getMetasTienda(token: String, date: string, idTienda: number) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Tienda/metas/" + date + "/" + idTienda;
    return this.http.get(url, requestOptions);
  }

  getMetasTiendaAcumulado(token: String, dateIni: string, dateEnd: string, idTienda: number) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Tienda/metasRango/" + dateIni + "/" + dateEnd + "/" + idTienda;
    return this.http.get(url, requestOptions);
  }

  setMetas(token: String, data: any) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
      responseType: "text"
    });
    const url = this.config.urlService + "api/Tienda/AsignarMetaTienda"
    return this.http.post(url, data, requestOptions);
  }

}
